export default {
  data() { },
  methods: {
    parseCsv: (val = []) => {
      let customers = []

      val.forEach(function (item) {
        // Parse empty trailing spaces
        for (var index in item) {
          if (item[index]) item[index] = item[index].trim()
          if (!item[index]) item[index] = null
        }

        // Parse multiple email if available
        if (item.emailAddress) {
          let emailAddresses = item.emailAddress.split(';')

          // Store first email as main email
          item.emailAddress = emailAddresses[0]

          // Store all email addresses
          let contactEmailAddresses = []
          emailAddresses.forEach(item => {
            if (item.length > 0) {
              contactEmailAddresses.push({ emailAddress: item })
            }
          })

          item.contactEmailAddresses = contactEmailAddresses
        }
        // Parse payment term type enum
        item.paymentTermType = item.paymentTermType
          ? item.paymentTermType.toLowerCase()
          : 'no payment term'

        //set value to lowercase
        item.type = item.type.toLowerCase()

        customers.push({
          customerId: item.customerid,
          name: item.name,
          emailAddress: item.emailAddress,
          type: item.type,
          paymentTermType: item.paymentTermType,
          netPaymentTermDay: item.netPaymentTermDay,
          address1: item.address1,
          address2: item.address2,
          city: item.city,
          state: item.state,
          postalCode: item.postalCode,
          country: item.country,
          phone: item.phone,
          reference1: item.reference1,
          reference2: item.reference2,
          reference3: item.reference3,
          notes: item.notes,
          parentCustomerId: item.parentCustomerId,
          accountManagerEmailAddress: item.accountManagerEmailAddress,
          ...(item.deliveryPIC ? { deliveryPIC: item.deliveryPIC } : {}),
          ...(item.deliveryAddress1
            ? { deliveryAddress1: item.deliveryAddress1 }
            : {}),
          ...(item.deliveryAddress2
            ? { deliveryAddress2: item.deliveryAddress2 }
            : {}),
          tin: item.tin,
          registrationNo: item.registrationNo,
          sst: item.sst,
        })
        //customers.push(item);
      })
      console.log(JSON.stringify(customers))
      return customers
    },
  },
}
